export enum BundleListingTypeEnum {
  COMPLETED = '1',
  ALL = '0',
}
